<div class="content-blk dv-pblshd-prdct">
  <div class="container">
    <h5 class="page-title">
      Published Products
      <small class="pull-right title-link">
        <a (click)="showAddProductWindow()" [routerLinkActive]="['active-link']">Design New</a>
        <a [routerLink]="['/store/customizedproducts']">Product Library</a>
      </small>
      <span class="clearfix"></span>
    </h5>
    <div class="white-background">
      <small class="text-info">One time $25 per side will be charged on first order as a Embroidery setup fees. Order will not be fulfilled incase of failed payments for Embroidery setup cost.</small>
      <br />
      <form class="example-form  pull-right" [formGroup]="storeadminStoreForm">
        <div class="srch-flt-rt">

          <mat-form-field>
            <mat-select placeholder="Store Name" class="order-st-select" (selectionChange)="fn_setStoreValue($event.value)" formControlName="StoreId">
              <mat-option *ngFor="let item of storeList; let i=index" [value]="item.StoreId">{{item.StoreName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>

      <div class="search-results" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="100" (scrolled)="fn_GetPublishedProductList(true)">
        <div class="sp-admin-list-tbl pro-tble-outer cmsn-list cmsn-bx-ut dv-pbls-prdct-lst">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th width="250">Product Description</th>
                  <th ><abbr title="Starting Cost of Product inlcludes only one print location">Product Cost </abbr></th>
                  <th width="80">($) Profit</th>
                  <th width="180" *ngIf="HasDiscount"><abbr title="Your additional profit for discount on products">Additional profit</abbr></th>
                  <th width="180">($) Additonal Price</th>
                  <th >Selling Price</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr [ngStyle]="{'display': isLoading === '' ? 'none' : isLoading}">
                  <td colspan="4" style="text-align:center">Loading...</td>
                </tr>
                <tr style="display: none;" [ngStyle]="{'display': isDisplay}">
                  <td colspan="4" style="text-align:center">No record(s) available</td>
                </tr>

                <tr *ngFor="let item of StorePublishedProductList; let i=index;" [ngClass]="{'discontinuedProduct': !item.ProductDescription.IsActive}">
                  <td>{{i + 1}}</td>
                  <td class="img-td-tble">
                    <div class="mat-sz-avt">
                      <a *ngIf="item.IsWarehouseProduct==false" [routerLink]="['/store/product/details']"
                         [queryParams]="{ pid: item.ProductId,designId:item.DesignId,type:1}">
                        <img [src]="item.ImageName">
                      </a>
                      <!--if warehouse  product-->
                      <a *ngIf="item.IsWarehouseProduct==true" [routerLink]="['/store/product/details']"
                         [queryParams]="{ pid: item.ProductId,designId:item.DesignId,type:1}">
                        <img style="height:83px;" [src]="item.ImageName">
                      </a>
                    </div>
                    <div class="mat-sz-ct">
                      <div class="mat-sz-inr">
                        <h4>
                          {{item.Name}}
                          <a [routerLink]="['/store/product/details']"
                             [queryParams]="{ pid: item.ProductId,designId:item.DesignId,type:1}" target="_blank">
                            <i class="fa fa-external-link-square" aria-hidden="true"></i>
                          </a>
                        </h4>
                        <div class="strng-col" title="{{item.ProductDescription.ProductName}}">
                          {{ item.ProductDescription.ProductName.length> 30 ? (item.ProductDescription.ProductName | slice:0:30)+'..':(item.ProductDescription.ProductName) }}
                          <br *ngIf="!item.ProductDescription.IsActive" /><br />
                          <span class="text-info">{{item.CustomizationType}}</span>
                          <small *ngIf="!item.ProductDescription.IsActive" class="discontinuedText">***Discontinued</small>

                          <div *ngIf="item.ProductDescription.SellingPrice > 0">
                            <span (click)="showCost=-1" class="detialView" *ngIf="showCost===i">Hide Details</span>
                            <span (click)="showCost=i" class="detialView" *ngIf="showCost !=i">Show Details</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="example-full-width">
                    <span *ngIf="item.ProductDescription.SellingPrice <= 0"> {{item.ProductDescription.UnitCost | currency:'USD':'symbol':'1.0-2'}}</span>
                    <div *ngIf="item.ProductDescription.SellingPrice > 0">
                      <small>Starting &nbsp;</small>
                      <small style="text-decoration:line-through" *ngIf="item.ProductDescription.UnitCostWithoutDiscount != item.ProductDescription.UnitCost">
                        {{item.ProductDescription.UnitCostWithoutDiscount | currency:'USD':'symbol':'1.0-2'}}
                      </small>
                      &nbsp;
                      {{item.ProductDescription.UnitCost | currency:'USD':'symbol':'1.0-2'}}
                      <br />
                      <span *ngIf="item.PrintingCost > 0">
                        <small class="text-muted">*including additional printing cost </small>
                        {{item.PrintingCost | currency:'USD':'symbol':'1.0-2'}}
                      </span>
                      <div class="table-responsive price-height" *ngIf="showCost===i">
                        <table class="published-colors-table">
                          <tr *ngFor="let color of item.PricePerSizeStyle;let isFirst = first" class="greyBackground">
                            <td *ngIf="isFirst" class="greyBackground">
                            </td>
                            <td *ngIf="isFirst" class="greyBackground">
                              <table style="font-weight: 600;" class="greyBackground">
                                <tr>
                                  <td *ngFor="let size of color.Sizes;">{{size.Name}}</td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr *ngFor="let color of item.PricePerSizeStyle;">
                            <td *ngIf="item.IsWarehouseProduct==false" class="greyBackground">
                              <span [ngStyle]="displayColor('#'+color.ColorCode)" class="published-colors"
                                    title="{{color.StyleName}}" *ngIf="color.IsActive">
                                &nbsp;
                              </span>
                              <span [ngStyle]="displayColor('#'+color.ColorCode)"
                                    title="{{color.StyleName}} ***Discontinued"
                                    class="discontinuedColor published-colors" *ngIf="!color.IsActive">
                                &nbsp;
                              </span>
                            </td>
                            <td *ngIf="item.IsWarehouseProduct==true" class="greyBackground">
                              <span [ngStyle]="displayColor(color.ColorCode)" class="published-colors"
                                    title="{{color.StyleName}}" *ngIf="color.IsActive">
                                &nbsp;
                              </span>
                              <span [ngStyle]="displayColor(color.ColorCode)"
                                    title="{{color.StyleName}} ***Discontinued"
                                    class="discontinuedColor published-colors" *ngIf="!color.IsActive">
                                &nbsp;
                              </span>
                            </td>
                            <td>
                              <table>
                                <tr [ngClass]="{'discontinuedColor': !color.IsActive}">
                                  <td *ngFor="let size of color.Sizes;" [title]="color.IsActive ? size.Name : '***Discontinued'">
                                    {{size.UnitPrice | currency:'USD':'symbol':'1.0-2'}}
                                    <small style="text-decoration:line-through" *ngIf="size.UnitPriceWithoutDiscount != size.UnitPrice">
                                      {{size.UnitPriceWithoutDiscount | currency:'USD':'symbol':'1.0-2'}}
                                    </small>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="item.IsWarehouseProduct==false" class="example-full-width">
                    <mat-form-field class="example-full-width"> 
                    <input #brandCheckbox matInput placeholder="Retail Price" value="{{item.RetailPrice}}" [disabled]="item.CustomizedProductId != enableCustomizedProductId" min="0" type="number" pattern="^\d{0,6}(\.\d{1,2})?$" (change)="fn_testPattern(brandCheckbox,item.CustomizedProductId)">
                  </mat-form-field>
                    <mat-error *ngIf="isvalidRetail == true && enableupdatebuttononId==0 && item.CustomizedProductId == enableCustomizedProductId ">
                      <strong>Allow only 6 digit with 2 decimal precision </strong>
                    </mat-error>  

                    <button *ngIf="item.CustomizedProductId != enableupdatebuttononId && item.ProductDescription.IsActive"
                            class="btn btn-link edit-button" (click)="fneditrow(i, item.CustomizedProductId)">
                      <i class="material-icons">edit</i>
                    </button>

                    <button *ngIf="item.CustomizedProductId == enableupdatebuttononId && item.ProductDescription.IsActive"
                            class="btn btn-link edit-button" (click)="fnupdaterow(item.CustomizedProductId, brandCheckbox,item.DesignId,item.RetailPrice,item.ProductDescription.SellingPrice)">
                      <i class="material-icons">  done </i>
                    </button>

                  </td>
                  <td *ngIf="item.IsWarehouseProduct==true" class="example-full-width">
                    {{item.RetailPrice}}
                  </td>
                  <td *ngIf="HasDiscount">
                    <span *ngIf="item.IsWarehouseProduct==false">{{item.ProductDescription.Discount | currency:'USD':'symbol':'1.0-2'}}</span>
                    <span *ngIf="item.IsWarehouseProduct==true">N/A</span>
                  </td>
                  <td class="text-info">
                    <strong *ngIf="item.FinshingPrice>0">Finishing Price: {{item.FinshingPrice | currency:'USD':'symbol':'1.0-2'}}</strong><br />
                    <strong *ngIf="item.EmbroideryCost>0">Embroidery Price: {{item.EmbroideryCost | currency:'USD':'symbol':'1.0-2'}}</strong><br />
                  </td>
                  <td class="example-full-width">
                    <div *ngIf="item.ProductDescription.SellingPrice > 0 && item.IsWarehouseProduct ==false">
                      <small>Starting &nbsp;</small>{{item.ProductDescription.SellingPrice | currency:'USD':'symbol':'1.0-2'}}
                      <div class="table-responsive price-height" *ngIf="showCost===i">
                        <table class="published-colors-table">
                          <tr *ngFor="let color of item.PricePerSizeStyle;let isFirst = first" class="greyBackground">
                            <td *ngIf="isFirst" class="greyBackground">
                            </td>
                            <td *ngIf="isFirst" class="greyBackground">
                              <table style="font-weight: 600;" class="greyBackground">
                                <tr>
                                  <td *ngFor="let size of color.Sizes;">{{size.Name}}</td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr *ngFor="let color of item.PricePerSizeStyle;">
                            <td class="greyBackground">
                              <span [ngStyle]="displayColor('#'+color.ColorCode)" class="published-colors"
                                    title="{{color.StyleName}}" *ngIf="color.IsActive">
                                &nbsp;
                              </span>
                              <span [ngStyle]="displayColor('#'+color.ColorCode)"
                                    title="{{color.StyleName}} ***Discontinued"
                                    class="discontinuedColor published-colors" *ngIf="!color.IsActive">
                                &nbsp;
                              </span>
                            </td>
                            <td>
                              <table>
                                <tr [ngClass]="{'discontinuedColor': !color.IsActive}">
                                  <td *ngFor="let size of color.Sizes;" [title]="color.IsActive ? size.Name : '***Discontinued'">
                                    {{size.UnitPriceWithoutDiscount + item.RetailPrice| currency:'USD':'symbol':'1.0-2'}}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div *ngIf="item.ProductDescription.SellingPrice > 0 && item.IsWarehouseProduct ==true">
                      <small>Starting &nbsp;</small>{{item.ProductDescription.SellingPrice| currency:'USD':'symbol':'1.0-2'}}
                      <div class="table-responsive price-height" *ngIf="showCost===i">
                        <table class="published-colors-table">
                          <tr *ngFor="let color of item.PricePerSizeStyle;let isFirst = first" class="greyBackground">
                            <td *ngIf="isFirst" class="greyBackground">
                            </td>
                            <td *ngIf="isFirst" class="greyBackground">
                              <table style="font-weight: 600;" class="greyBackground">
                                <tr>
                                  <td *ngFor="let size of color.Sizes;">{{size.Name}}</td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr *ngFor="let color of item.PricePerSizeStyle;">
                            <td class="greyBackground">
                              <span [ngStyle]="displayColor(color.ColorCode)" class="published-colors"
                                    title="{{color.StyleName}}" *ngIf="color.IsActive">
                                &nbsp;
                              </span>
                              <span [ngStyle]="displayColor(color.ColorCode)"
                                    title="{{color.StyleName}} ***Discontinued"
                                    class="discontinuedColor published-colors" *ngIf="!color.IsActive">
                                &nbsp;
                              </span>
                            </td>
                            <td>
                              <table>
                                <tr [ngClass]="{'discontinuedColor': !color.IsActive}">
                                  <td *ngFor="let size of color.Sizes;" [title]="color.IsActive ? size.Name : '***Discontinued'">
                                    {{size.UnitPriceWithoutDiscount| currency:'USD':'symbol':'1.0-2'}}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="item.IsWarehouseProduct==false" class="tble-two-btn-grop actn-lst-edt text-center">
                    <button mat-raised-button (click)="fndeleterow(item.CustomizedProductId,item.DesignId)" class="delete-button">
                      <i class="material-icons">  delete_outline </i>
                    </button>
                  </td>
                  <td *ngIf="item.IsWarehouseProduct==true" class="tble-two-btn-grop actn-lst-edt text-center">
                    <button mat-raised-button (click)="fndeleterowWarehouseProduct(item.WareHouseProductId)" class="delete-button">
                      <i class="material-icons">  delete_outline  </i>
                    </button>
                  </td>
                </tr>
              </tbody>

              <!-- style="display: none;" [ngStyle]="{'display': isDisplay}" -->
              <!-- <tbody [ngStyle]="{'display': isLoading === '' ? 'none' : isLoading}">
                <tr>
                  Loading...
                </tr>
              </tbody> -->
            </table>
          </div>
          <app-lazy-loader></app-lazy-loader>
        </div>
      </div>
    </div>

  </div>
</div>
